import { NotificationsModel } from 'src/app/models/notifications.model';

export class NotificationStateModel {
    notifications: NotificationsModel;
    notificationLimit = 10;
    unReadNotificationCount = 0;
    unReadOnlineOrdersCounter = 0;
}
